export default __webpack_public_path__ + "static/media/icons-project-schedule.3e7309ba.svg";